import * as PropertyTypes from 'customer-data-objects/property/PropertyTypes';
import { swapOperator } from 'customer-data-filters-ui/filterQueryFormat/operator/Operator';
import { useValidateCondition } from './useValidateCondition';
import { DATE_REFINEMENT, NUMBER_REFINEMENT } from 'customer-data-filters-ui/converters/objectSeg/constants/constants';
export const useConditionRefinementChange = (filterFamily, condition, onChange, refinementType, emptyRefinementCondition) => {
  const {
    validateCondition
  } = useValidateCondition();
  const refinementFieldName = refinementType === PropertyTypes.NUMBER ? NUMBER_REFINEMENT : DATE_REFINEMENT;
  const onRefinementChange = (newRefinement, shouldValidate = true) => {
    let newCondition;
    if (shouldValidate) {
      const validatedNewRefinement = validateCondition(filterFamily, newRefinement);
      newCondition = condition.set(refinementFieldName, validatedNewRefinement);
    } else {
      newCondition = condition.set(refinementFieldName, newRefinement.remove('errors'));
    }
    onChange(newCondition);
  };
  const onRefinementOperatorChange = newOperator => {
    const currentInstance = condition[refinementFieldName] || emptyRefinementCondition;
    if (currentInstance) {
      const newRefinement = swapOperator(newOperator, currentInstance);
      onRefinementChange(newRefinement, false);
    }
  };
  const onRefinementValueChange = newRefinement => {
    onRefinementChange(newRefinement);
  };
  const onRefinementDelete = () => {
    const newCondition = condition.set(refinementFieldName, undefined);
    onChange(newCondition);
  };
  return {
    onRefinementOperatorChange,
    onRefinementValueChange,
    onRefinementDelete
  };
};